import { UploadFile } from '@mui/icons-material';
import Button from '@mui/material/Button';
import React, { useState } from 'react';
import Modal from '../elements/Modal';
import UploadJSONForm from './UploadJSONForm';
import { createBulkProduct } from '../../api/products';

export default function AddProduct({
  fetchData,
  token,
  setMessage,
  setSnackbarOpen,
  alreadyUploading,
}) {
  const [loading, setLoading] = useState(false);
  const [openJSONPopup, setOpenJSONPopup] = useState(false);
  const [errorJSON, setErrorJSON] = useState(null);
  const [fileName, setFileName] = useState('');
  const [files, setFiles] = useState('');
  const handleFile = (e) => {
    setFiles(null);
    if (e.target.files.length === 0) {
      return false;
    }
    setFiles(e.target.files[0]);
  };

  const handleSubmit = async () => {
    setErrorJSON(null);
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', files);
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/v2/products/autosuggest/upload`,
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: token,
          },
        }
      );
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      const result = await createBulkProduct(token)
      if (!result.ok) {
        const errorResponse = await result.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setLoading(false);
      setMessage('Products added successfully');
      fetchData();
      handleCloseJSONPopup();
    } catch (error) {
      setLoading(false);
    }
  };

  const handleClickOpenJSONPopup = () => {
    setOpenJSONPopup(true);
  };

  const handleCloseJSONPopup = () => {
    setOpenJSONPopup(false);
    setFiles(null);
    setFileName(null);
    setErrorJSON(null);
  };

  return (
    <div>
      {!alreadyUploading && (
        <Button
          variant="contained"
          color="secondary"
          sx={{ ml: 2 }}
          startIcon={<UploadFile />}
          onClick={handleClickOpenJSONPopup}>
          Upload CSV
        </Button>
      )}
      <Modal
        open={openJSONPopup}
        modalTitle="Add Products"
        handleClose={handleCloseJSONPopup}
        width={'sm'}>
        <UploadJSONForm
          handleSubmit={handleSubmit}
          token={token}
          handleFile={handleFile}
          errorJSON={errorJSON}
          fileName={fileName}
          files={files}
          loading={loading}
          handleCloseJSONPopup={handleCloseJSONPopup}
        />
      </Modal>
    </div>
  );
}
